import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Icon = ({ d }: { d: string }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);

export function TabBar() {
  const { t } = useTranslation();
  const items = [
    { to: '/', label: t('nav.home'), d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z' },
    { to: '/search', label: t('nav.search'), d: 'M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z' },
    { to: '/add', label: t('nav.add'), d: 'M12 5v14M5 12h14' },
    { to: '/notifications', label: t('nav.notifications'), d: 'M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9' },
    { to: '/profile', label: t('nav.profile'), d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z' },
  ];
  return (
    <nav
      aria-label="Primary"
      className="sticky bottom-0 z-40 flex items-stretch md:hidden"
      style={{
        background: 'color-mix(in srgb, var(--surface) 96%, transparent)',
        backdropFilter: 'saturate(160%) blur(10px)',
        borderTop: '1px solid var(--border)',
        paddingBottom: 'env(safe-area-inset-bottom, 0)',
      }}
    >
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.to === '/'}
          className={({ isActive }) =>
            [
              'flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold',
              isActive ? 'text-soi-600' : 'text-ink-muted',
              'min-h-[56px]',
            ].join(' ')
          }
        >
          <Icon d={it.d} />
          <span>{it.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
